<mic-breadcrumb id="disposal-charges-breadcrumb">
  <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
  <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
  <mic-breadcrumb-link label="{{ translationService.translate('disposalChargeSetupText') }}"></mic-breadcrumb-link>
</mic-breadcrumb>

<h1 class="mt-4 mb-4">{{ this.translationService.translate('disposalChargeSetupText') }}</h1>

<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isLoading">
  <div style="display: flex; justify-content: flex-end; padding-bottom: 12px">
    <span
      [matTooltip]="
        productSaveDisabled
          ? this.translationService.translate('comingSoonText')
          : !saveEnabled
          ? this.translationService.translate('userCannotSaveText')
          : !isModified
          ? this.translationService.translate('noModifiedText')
          : null
      "
      matTooltipPosition="above"
    >
      <button id="save" type="button" mat-flat-button color="primary" (click)="save()" [disabled]="!saveEnabled || !isModified">
        <mat-icon>save</mat-icon>
        {{ translationService.translate('saveLinkText') }}
      </button>
    </span>
  </div>

  <div id="disposal-charges-table" class="cam-table table-container">
    <mic-table class="table-stripped" [config]="tableConfig" [dataSource]="disposalCharges">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'rmPartNum'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [widthConfig]="{ width: '100%' }"
          [virtualScroll]="true"
          [data]="rmPartNums"
          [formControl]="getControl(item, 'rmPartNum')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'fgPartNum'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [widthConfig]="{ width: '100%' }"
          [virtualScroll]="true"
          [data]="fgPartNums"
          [formControl]="getControl(item, 'fgPartNum')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'default'">
        <mat-checkbox [formControl]="getControl(item, 'defaultDisposalCharges')"></mat-checkbox>
      </ng-container>
    </mic-table>

    <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
    <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
  </div>
</mic-spinner-overlay>
